// extracted by mini-css-extract-plugin
export default {"tagcloud-wrapper":"TagCloud_tagcloud-wrapper__qBuQ9","tagcloud-popover-trigger":"TagCloud_tagcloud-popover-trigger__tQ1Fu"};